import { ApplicationService } from '~/services/core/application.service'

// TODO:
//  - Create offer interfaces to use as return type
export class RatingService extends ApplicationService {
  get baseUrl () {
    return this.runtimeConfig.BASE_API_URL
  }

  create (payload = {}) {
    return this.post('/amp/api/v1/feedback/ratings/create', payload)
  }

  getReviewsList (params = {}) {
    return this.post('/amp/api/v1/feedback/ratings/search', params)
  }
}
